<template>
  <mdb-card>
    <mdb-card-body>
      <mdb-input :label="inputLabel" :placeholder="inputPlaceholder" @input="isTyping = true"
                 aria-label="Find a Member" type="text"
                 v-model="query"/>
      <mdb-row>
        <div :key="m.id" class="col-md-3 d-flex align-self-stretch"
             v-for="m in memberList">
          <div class="card profile-card text-center mb-4">
            <div class="avatar mb-4">
              <avatar :avatar="m.avatar" :reputation="m.reputation"
                      :size="100" containerClass=""/>
            </div>
            <div class="card-body pt-0 mt-0">
              <h3 class="mb-3 font-weight-bold"><strong>{{m.name}}</strong></h3>
              <mdb-btn @click="selectMember(m)" icon="check-circle" rounded size="sm">Select</mdb-btn>
            </div>
          </div>
        </div>
      </mdb-row>
      <mdb-btn :disabled="executing" @click="doCancelSearch" color="success" icon="times-circle"
               v-if="memberList.length>0">Cancel
      </mdb-btn>
    </mdb-card-body>
  </mdb-card>

</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import Avatar from "../common/Avatar"
import {mdbBtn, mdbCard, mdbCardBody, mdbCol, mdbIcon, mdbInput, mdbRow} from 'mdbvue';

export default {
    name: 'MemberLookup',
    components: {
      mdbBtn,
      mdbIcon,
      mdbInput,
      mdbRow,
      mdbCol,
      Avatar,
      mdbCard,
      mdbCardBody
    },
    props: {
      inputLabel: {
        type: String,
        default: "Member Name"
      },
      inputPlaceholder: {
        type: String,
        default: "Type name of member to lookup"
      }
    },
    computed: {
      userDetails() {
        return this.$store.state.userDetails
      },
      group() {
        return this.$store.state.currentGroup
      },
      executing() {
        return this.$store.state.executing
      }
    },
    watch: {
      query: _.debounce(function () {
        this.isTyping = false;
      }, 790),
      isTyping: function (value) {
        if (!value) {
          this.loadMemberList()
        }
      }

    },
    data() {
      return {
        query: "",
        isTyping: false,
        memberList: [],
      }
    },
    methods: {
      loadMemberList() {
        if (!this.query) return
        this.$store.dispatch("setExecuting", false)
        api.get("/member/lookup/" + this.group.vanityPath + "/?q=" + this.query).then(
          (results) => {
            this.memberList = results.data.members
          },
          (error) => {
            this.$notify.error({message: "Could not load members. " + error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      doCancelSearch() {
        this.memberList = []
        this.query = ""
        this.$emit("cancelSearch")
      },
      selectMember(m) {
        this.$emit("selectedMember", m)
        this.memberList = []
        this.query = ""
      }
    }
  }
  ;
</script>
<style scoped>
  p {
    line-height: 1em;
    margin-bottom: 5px;
  }

  .profile-card {
    margin-top: 100px;
  }

  .profile-card .avatar {
    max-width: 150px;
    max-height: 150px;
    margin: -70px auto 0;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    overflow: hidden;
  }

  .cascading-admin-card .admin-up {
    margin-left: 4%;
    margin-right: 4%;
    margin-top: -20px;
  }

  .cascading-admin-card .admin-up .fa {
    padding: 1.7rem;
    font-size: 2rem;
    color: #fff;
    text-align: left;
    margin-right: 1rem;
    -webkit-border-radius: 3px;
    border-radius: 3px;
  }

  .cascading-admin-card .admin-up .fa, .z-depth-2 {
    -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);
    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);
  }

  .badge-container {
    position: absolute;
    right: 0;
  }

  .list-title-tools {
    position: absolute;
    right: 0;
    top: 0;
    padding-right: 10px;
  }

</style>
